import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
// operator/dashboard
import { operatorDashboardSlice } from "@/pages/operator/home/store";
// operator/reports
import { operatorMemberDepositSlice } from "@/pages/operator/reports/member-deposit/store";
import { operatorMemberWithdrawSlice } from "@/pages/operator/reports/member-withdraw/store";
import { operatorSelfDepositSlice } from "@/pages/operator/reports/self-deposit/store";
import { operatorSelfWithdrawSlice } from "@/pages/operator/reports/self-withdraw/store";
import { operatorTenantDepositSlice } from "@/pages/operator/reports/tenant-deposit/store";
import { operatorTenantWithdrawSlice } from "@/pages/operator/reports/tenant-withdraw/store";
// operator/management
import { operatorManageTenantSlice } from "@/pages/operator/management/tenants/store";
import { operatorManageWalletSlice } from "@/pages/operator/management/wallets/store";
// operator/dashboard
import { tenantDashboardSlice } from "@/pages/tenant/home/store";
// tenant/reports
import { tenantMemberDepositSlice } from "@/pages/tenant/reports/member-deposit/store";
import { tenantMemberWithdrawSlice } from "@/pages/tenant/reports/member-withdraw/store";
import { tenantSelfDepositSlice } from "@/pages/tenant/reports/self-deposit/store";
import { tenantSelfWithdrawSlice } from "@/pages/tenant/reports/self-withdraw/store";
// tenant/management
import { tenantMemberSlice } from "@/pages/tenant/management/members/store";
// tenant/reports
import { tenantDailyReportDepositSlice } from "@/pages/tenant/reports/daily-deposit/store";
import { tenantDailyReportWithdrawSlice } from "@/pages/tenant/reports/daily-withdraw/store";
import { tenantTransfersSlice } from "@/pages/tenant/reports/transfers/store";

export const store = configureStore({
  reducer: {
    // operator/dashboard
    operatorDashboard: operatorDashboardSlice.reducer,
    // operator/reports
    operatorMemberDeposit: operatorMemberDepositSlice.reducer,
    operatorMemberWithdraw: operatorMemberWithdrawSlice.reducer,
    operatorTenantDeposit: operatorTenantDepositSlice.reducer,
    operatorTenantWithdraw: operatorTenantWithdrawSlice.reducer,
    operatorSelfDeposit: operatorSelfDepositSlice.reducer,
    operatorSelfWithdraw: operatorSelfWithdrawSlice.reducer,
    // operator/management
    operatorManageTenant: operatorManageTenantSlice.reducer,
    operatorManageWallet: operatorManageWalletSlice.reducer,
    // tenant/dashboard
    tenantDashboard: tenantDashboardSlice.reducer,
    // tenant/reports
    tenantMemberDeposit: tenantMemberDepositSlice.reducer,
    tenantMemberWithdraw: tenantMemberWithdrawSlice.reducer,
    tenantSelfDeposit: tenantSelfDepositSlice.reducer,
    tenantSelfWithdraw: tenantSelfWithdrawSlice.reducer,
    // tenant/management
    tenantMember: tenantMemberSlice.reducer,
    // tenant/reports
    tenantDailyReportDeposit: tenantDailyReportDepositSlice.reducer,
    tenantDailyReportWithdraw: tenantDailyReportWithdrawSlice.reducer,
    tenantTransfers: tenantTransfersSlice.reducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
